var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from 'react';
import styled from '@emotion/styled';
import { display, justifyContent, alignItems, height, space, width, flexDirection, verticalAlign, maxWidth, } from 'styled-system';
import { themeHeight, themeMaxHeight, themeMaxWidth, themeWidth, } from '../theme/system-utilities';
import { CenterLeftControls, CenterRightControls, } from './LazyCarousel/Control';
import { Grid } from './Grid';
import { ResponsiveLazyImageMemo } from './LazyImage';
import { BackgroundImage } from './BackgroundImage';
import LazyCarousel from './LazyCarousel';
import Ratio from './Ratio';
import { SmallHeading } from './Text';
import { ThemedMedia } from './Media';
import arrowLeftIcon from '../assets/icons/arrow-left.svg';
import { urlToLazyImageProps } from '../utils/cdn';
/**
 * @TODO Code refactoring needed.
 * We should consider a refactoring of this logic involving these `SLIDES_TO_SHOW_*`
 * and `SLIDE_WIDTH_*` variables. Most of this logic was ported during the carousel
 * library migration from `nuka-carousel` to `@glidejs/glide` and it's probably no longer needed.
 * Another reason for a refactoring is that this logic is no longer accurate, for example:
 * Right below, we have `SLIDES_TO_SHOW_XL` with the value 5, assuming 5 slides should be shown in the
 * Extra Large (XL) breakpoint. However, 6 and a half slides are actually shown in the component.
 */
export var IMAGE_RATIO = 0.72;
var SLIDES_TO_SHOW_XL = 5;
var SLIDES_TO_SHOW_L = 4;
var SLIDES_TO_SHOW_M = 3;
var SLIDES_TO_SHOW_S = 2;
var SLIDE_WIDTH_LARGE_DESKTOP = 0.85;
var SLIDE_WIDTH_DESKTOP = 0.85;
var SLIDE_WIDTH_TABLET = 0.72;
var SLIDE_WIDTH_MOBILE = 0.81;
var SLIDE_FALLBACK_WIDTH = [
    SLIDE_WIDTH_MOBILE / SLIDES_TO_SHOW_S,
    SLIDE_WIDTH_TABLET / SLIDES_TO_SHOW_M,
    SLIDE_WIDTH_DESKTOP / SLIDES_TO_SHOW_L,
    SLIDE_WIDTH_LARGE_DESKTOP / SLIDES_TO_SHOW_XL,
];
var IMAGE_SIZES = {
    thumbnail: 53,
    mobile: 107,
    tablet: 142,
    desktop: 190,
    large_desktop: 192,
};
var getResponsiveImageShape = function (image) {
    return typeof image !== 'string' ? image : urlToLazyImageProps(image, IMAGE_SIZES);
};
var VisualNavigationGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  overflow: hidden;\n"], ["\n  ", ";\n  overflow: hidden;\n"])), flexDirection);
VisualNavigationGrid.defaultProps = {
    py: 0,
    px: ['sp_16', 'sp_24', '36px', 'sp_64'],
    mb: ['sp_16', 'sp_24', null, 'sp_32'],
};
var VisualNavigationHeader = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), space);
VisualNavigationHeader.defaultProps = {
    mb: ['sp_12', 'sp_20', 'sp_24'],
};
var SlideContainer = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  text-decoration: none;\n  cursor: pointer;\n"], ["\n  ", ";\n  ", ";\n  text-decoration: none;\n  cursor: pointer;\n"])), display, space);
SlideContainer.defaultProps = {
    display: 'block',
    mr: ['sp_16', '18px', 'sp_20', 'sp_16'],
};
var SlideImage = styled(ResponsiveLazyImageMemo)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, width, height);
SlideImage.defaultProps = {
    display: 'block',
    width: 1,
    height: 'auto',
};
var SlideDescriptionWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  word-break: break-word;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  word-break: break-word;\n"])), display, justifyContent, alignItems, space);
SlideDescriptionWrapper.defaultProps = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    mt: ['10px', '11px', '15px', '12px'],
};
var SlideDescription = styled(SmallHeading)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), maxWidth);
SlideDescription.defaultProps = __assign(__assign({}, SmallHeading.defaultProps), { as: 'p', mx: 0, my: 0, lineHeight: ['lh_20', 'lh_24', null, '26px'], fontSize: ['fs_14', 'fs_16', null, 'fs_18'], fontWeight: 'normal', textAlign: 'center', maxWidth: '86%' });
var LeftArrow = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"])), themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, space, verticalAlign);
LeftArrow.defaultProps = {
    src: arrowLeftIcon,
    alt: '',
    themeWidth: [3, '18px', null, '20px'],
    themeMaxWidth: [3, '18px', null, '20px'],
    themeHeight: [3, '18px', null, '20px'],
    themeMaxHeight: [3, '18px', null, '20px'],
    ml: 'sp_4',
    mb: '2px',
    verticalAlign: 'middle',
};
var StyledCenterLeftControls = styled(CenterLeftControls)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-left: 2px;\n"], ["\n  margin-left: 2px;\n"])));
var StyledCenterRightControls = styled(CenterRightControls)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-right: 2px;\n"], ["\n  margin-right: 2px;\n"])));
export var VisualNavigation = function (props) {
    var items = props.items, seeAllLink = props.seeAllLink;
    var _a = __read(useState(0), 2), activeSlide = _a[0], setActiveSlide = _a[1];
    var renderCenterLeftControls = useCallback(function (controlProps) { return (React.createElement(StyledCenterLeftControls, __assign({ isVisualNavigation: true }, controlProps))); }, []);
    var renderCenterRightControls = useCallback(function (controlProps) { return (React.createElement(StyledCenterRightControls, __assign({ isVisualNavigation: true, slidesToShow: true, seeAllLink: seeAllLink }, controlProps))); }, [seeAllLink]);
    var handleAfterSlide = useCallback(function (currentSlide) {
        setActiveSlide(currentSlide);
    }, [activeSlide]);
    return (React.createElement(ThemedMedia, null, function (matches) {
        var slidesToShow = SLIDES_TO_SHOW_S;
        if (matches.large_desktop) {
            slidesToShow = SLIDES_TO_SHOW_XL;
        }
        else if (matches.desktop) {
            slidesToShow = SLIDES_TO_SHOW_L;
        }
        else if (matches.tablet) {
            slidesToShow = SLIDES_TO_SHOW_M;
        }
        /**
         * In order to show always, for each breakpoint, a defined number of slides, we have
         * to manually set the slideWidth, to overwrite the default behaviour (=> slider-width / slides-total-number),
         * and the slidesToShow, to define the number of slides we want to show at once.
         * WARNING: If the slideWidth that is passed to Carousel is
         * changed, please update SlideContainer width values
         */
        var slideWidth = matches.desktop
            ? SLIDE_WIDTH_DESKTOP
            : matches.tablet
                ? SLIDE_WIDTH_TABLET
                : SLIDE_WIDTH_MOBILE;
        var isMobile = matches.tablet === false;
        return (React.createElement(LazyCarousel, { renderCenterLeftControls: renderCenterLeftControls, renderCenterRightControls: renderCenterRightControls, hideBottomControls: true, frameOverflow: matches.large_desktop ? 'hidden' : 'visible', slidesToShow: slidesToShow, slideWidth: slideWidth, 
            // WARNING: If the slideWidth that is passed to Glide Carousel is
            // changed, please update these values
            fallbackSlideWidth: SLIDE_FALLBACK_WIDTH, scrollToTheLastSlide: isMobile, afterSlide: handleAfterSlide, showControlsOnTouchDevice: true, overflowHidden: true }, items.map(function (_a, index) {
            var link = _a.link, description = _a.description, imageProps = _a.image;
            return (React.createElement(SlideContainer, __assign({ key: "slide-" + index }, (index - activeSlide <= slidesToShow && {
                'data-prefetch': true,
            }), { "data-testid": "visual-navigation-slide-" + index, href: link }),
                React.createElement(Ratio, { ratio: IMAGE_RATIO },
                    React.createElement(SlideImage, __assign({}, getResponsiveImageShape(imageProps)), function (_a) {
                        var loaded = _a.loaded, image = _a.image, thumbnail = _a.thumbnail, innerRef = _a.innerRef;
                        return (React.createElement(BackgroundImage, { "data-testid": "image-slide", ref: innerRef, src: loaded ? image : thumbnail, alt: description }));
                    })),
                React.createElement(SlideDescriptionWrapper, null,
                    React.createElement(SlideDescription, { "data-testid": "description-slide" },
                        description,
                        React.createElement(LeftArrow, { "data-testid": "left-arrow" })))));
        })));
    }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
